import React, { useRef, useCallback , useState}from 'react';
import styled from 'styled-components';
import { AgGridReact } from 'ag-grid-react';
import { AgGridReact as AgGridReactType } from 'ag-grid-react';
import { type ColDef, themeAlpine} from 'ag-grid-community';
import '@process-advisor/process-miner/shared/gridStyles.css'
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { AlertMessage } from '@process-advisor/process-miner/components/alerts/alert';

import { workFlowGridColumnsMaster } from '@process-advisor/process-miner/workflows/workFlowGridColumnsMaster';
import { workFlowGridColumnsDetail } from '@process-advisor/process-miner/workflows/workFlowGridColumnsDetail';
import FilterIcon  from '@process-advisor/assets/filterIcon.png'
import ExportIcon  from '@process-advisor/assets/export.png'
import CSVIcon  from '@process-advisor/assets/CSVIcon.png'
import ExcelIcon  from '@process-advisor/assets/XLSIcon.png'
import RecommendIcon from '@process-advisor/assets/recommend.png'

const Wrapper = styled.div`
    width: 100%;
    padding: 5px;
`;

type SingleRow = {
    id: number;
    [key: string]: any
}

type Props = {
    rows: SingleRow[],
    nodeDataArray: any,
    linkDataArray: any
}

export type Row = {};

export const DataGrid: React.FC<Props> = ({rows}) => {
    const sleep = ms => new Promise(r => setTimeout(r, ms));
    const [columnDefs, setColumnDefs] = useState<ColDef[]>();
    const [detailColumnDefs, setDetailColumnDefs] = useState<ColDef[]>();

    React.useEffect(() => {
        setColumnDefs(workFlowGridColumnsMaster)
        setDetailColumnDefs(workFlowGridColumnsDetail)
    }, []);
    
    const grid = useRef<AgGridReactType>(null);
    const getContextMenuItems = useCallback((params) => {
        let contextMenu = [
            {
                name: 'Filter',
                action: function () {
                    apiProvider.applyWorkflowFilter( {matching_variants: params.node.data.matching_variants, workflow: params.node.data.workflow} )
                },
                icon: '<img src="' + FilterIcon + '" />',
            },
            {
                name: 'View',
                action: function () {
                    apiProvider.viewWorkflowModal( {workflow: params.node.data.workflow, linkDataArray: params.node.data.linkDataArray, nodeDataArray: params.node.data.nodeDataArray} )
                },
                icon: '<img src="' + RecommendIcon + '" />',
            },
            'separator',
            {
                name: 'Export',
                icon: '<img src="' + ExportIcon + '" />',
                subMenu: [
                    {
                        name: 'CSV Export (all)',
                        action: () => params.api.exportDataAsCsv(
                            {onlySelected: false}
                          ),
                        icon: '<img src="' + CSVIcon + '" />',
                    },
                    {
                        name: 'CSV Export (selected)',
                        action: () => params.api.exportDataAsCsv(
                            {onlySelected: true}
                          ),
                        icon: '<img src="' + CSVIcon + '" />',
                    },
                    {
                        name: 'XLS Export (all)',
                        action: () => params.api.exportDataAsExcel(
                            {onlySelected: false}
                          ),
                        icon: '<img src="' + ExcelIcon + '" />',
                    },
                    {
                        name: 'XLS Export (selected)',
                        action: () => params.api.exportDataAsExcel(
                            {onlySelected: true}
                          ),
                        icon: '<img src="' + ExcelIcon + '" />',
                    },
                ],
            },        

        ]

        return contextMenu

    }, []);    

    const onGridReady = (params) => {
        //params.api.setColumnWidth('ag-Grid-AutoColumn', 600);
        params.api.forEachNode(node => {
            if (node.detailNode !== undefined) node.setExpanded(false);
        });
    };
    
    const isRowMaster = useCallback((dataItem: any) => {
        return dataItem ? dataItem.transition_detail.length > 0 : false;
      }, []);

    return (
        <Wrapper>
            <div
                
                style={{
                    height: '600px',
                    width: '100%',
                    fontSize: '12px',
                    fontFamily: 'system-ui'
,
                }}>
                <AgGridReact theme={themeAlpine} 
                    ref={grid}
                    rowSelection="single"
                    columnDefs={columnDefs}
                    allowContextMenuWithControlKey={true}
                    getContextMenuItems={getContextMenuItems}
                    overlayNoRowsTemplate={'Workflow configuration has not yet been imported'}
                    groupDefaultExpanded={2}
                    onGridReady={onGridReady}
                    masterDetail={true}
                    isRowMaster={isRowMaster}
                    detailRowAutoHeight = {true}
                    rowHeight={25}
                    headerHeight={60}
                    defaultColDef={{
                        filter: true,
                        resizable: true,
                        sortable: true,
                        wrapText: true,
                        autoHeight: true,
                    }}

                    groupDisplayType={'singleColumn'}
                    groupHideOpenParents={false}
                    
                    sideBar={
                        {
                            toolPanels: [
                                {
                                    id: 'columns',
                                    labelDefault: 'Columns',
                                    labelKey: 'columns',
                                    iconKey: 'columns',
                                    toolPanel: 'agColumnsToolPanel',
                                    toolPanelParams: {
                                        suppressRowGroups: true,
                                        suppressValues: true,
                                        suppressPivotMode: true, 
                                    }
                      
                                },
                                {
                                    id: 'filters',
                                    labelDefault: 'Filters',
                                    labelKey: 'filters',
                                    iconKey: 'filter',
                                    toolPanel: 'agFiltersToolPanel',
                                },
                            ],
                            hiddenByDefault: false,
                            defaultToolPanel: '',
                        }
                    }        
                    detailCellRendererParams={{
                        detailGridOptions: {
                            pagination: true,
                            suppressRowClickSelection: true,
                            columnDefs: detailColumnDefs,
                        },
                        getDetailRowData: params => {
                            params.successCallback(params.data.transition_detail);
                        },
                    }}            
                    rowData={rows} />
            </div>
            <AlertMessage/>
        </Wrapper>
    );
};
